import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type RedirectState = {
  redirectPath: string | null;
};

type RedirectActions = {
  setRedirectPath: (path: string | null) => void;
};

const useRedirectStore = create<RedirectState & RedirectActions>()(
  devtools(
    persist(
      set => ({
        redirectPath: null,
        setRedirectPath: (path: string | null) => set({ redirectPath: path }),
      }),
      {
        name: 'redirect',
        storage: {
          getItem: name => {
            const value = sessionStorage.getItem(name);
            return value ? JSON.parse(value) : null;
          },
          setItem: (name, value) => {
            sessionStorage.setItem(name, JSON.stringify(value));
          },
          removeItem: name => sessionStorage.removeItem(name),
        },
      },
    ),
  ),
);

export { useRedirectStore };
